import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { InlineToolbarButton, removeLinksInSelection } from 'wix-rich-content-editor-common';
import RemoveLinkIcon from '../icons/RemoveLinkIcon.js';
import { LINK_TYPE } from '../types.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class RemoveLinkButton extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "deleteLink", () => {
      const { getEditorState, setEditorState, closeInlinePluginToolbar } = this.props;
      const newEditorState = removeLinksInSelection(getEditorState(), setEditorState);
      setEditorState(newEditorState);
      closeInlinePluginToolbar();
    });
  }
  render() {
    const { theme, helpers, isMobile, t, tabIndex } = this.props;
    const linkButtonTooltip = t("LinkPanelContainer_RemoveButton");
    const buttonStyles = {
      button: theme.inlineToolbarButton,
      buttonWrapper: theme.inlineToolbarButton_wrapper,
      icon: theme.inlineToolbarButton_icon,
      active: theme.inlineToolbarButton_active
    };
    return /* @__PURE__ */ React.createElement(
      InlineToolbarButton,
      {
        onClick: this.deleteLink,
        helpers,
        theme: __spreadValues(__spreadValues({}, theme), buttonStyles),
        isMobile,
        tooltipText: linkButtonTooltip,
        tabIndex,
        icon: RemoveLinkIcon,
        dataHook: "RemoveLinkButton",
        pluginType: LINK_TYPE
      }
    );
  }
}
RemoveLinkButton.propTypes = {
  getEditorState: PropTypes.func.isRequired,
  setEditorState: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
  helpers: PropTypes.object,
  isMobile: PropTypes.bool,
  t: PropTypes.func,
  tabIndex: PropTypes.number,
  closeInlinePluginToolbar: PropTypes.func
};

export { RemoveLinkButton as default };
//# sourceMappingURL=RemoveLinkButton.js.map
